import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import AxiosInstance, { } from '../../Helper/AxiosInstance'
import { toast } from 'react-toastify';
import { Context } from '../../Helper/Context';
export default function Signup() {
  const { profile, ConnectWallet } = Context()
  const { referralId=null } = useParams()
  const [action, setAction] = useState({ btnLoader: false, sponserLoader: false, sponserVerify: false, message: '' })
  const [data, setData] = useState({ password: "", confpassword: "", referralId: "rrrrr" })
  const getInput = async (event) => {
    const target = event.currentTarget
    setData((prev) => ({ ...prev, [target.name]: target.value }))
  }
  const checkSponser = async () => {
    try {
      const refId = referralId || data.referralId;
      setData(prev=>({...prev, referralId: refId }))
      setAction((prev) => ({ ...prev, sponserLoader: true, sponserVerify: false, message: '' }))
      if(!refId) return
      const response = await AxiosInstance.get('/checkregno', { params: { regno: refId } })
      if (response.status === 1) {
        setAction((prev) => ({ ...prev, sponserVerify: true, message: response.data }))
        return
      }
      setAction((prev) => ({ ...prev, sponserVerify: false, message: 'Invalid referral id' }))
    } catch (err) {
      setAction((prev) => ({ ...prev, sponserVerify: false, message: 'Invalid referral id' }))
    } finally {
      setAction((prev) => ({ ...prev, sponserLoader: false }))
    }
  }
  const manageRequest = async (event) => {
    event.preventDefault()
    try {
      if (data.password !== data.confpassword) {
        toast.warn('Password are not match...!!', { position: 'top-center', autoClose: 700 })
        return
      }
      if (!action.sponserVerify) {
        toast.warn('check sponser id', { position: 'top-center', autoClose: 700 })
        return
      }
      setAction((prev) => ({ ...prev, btnLoader: true }))
      const response = await AxiosInstance.post('/registration', { usdtaddress: profile?.walletAddress, ...data})
      if (response.status === 1) {
        toast.success(response.mess, { position: 'top-center', autoClose: 700 })
        setData((prev) => ({ ...prev, usdtaddress: "", password: "", confpassword: "", referralId: "" }))
        return
      }
      toast.warn(response.mess, { position: 'top-center', autoClose: 700 })
    } catch (err) {
      toast.warn(err.response.data.mess, { position: 'top-center', autoClose: 700 })
    } finally {
      setAction((prev) => ({ ...prev, btnLoader: false }))
    }
  }
  useEffect(()=>{ checkSponser() },[referralId])
  return (<>
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="crypt-login-form mt-5">
          <div className="d-flex justify-content-between mb-4 text-center">
            <h3 className="fw-bold">Sign Up</h3>
          </div>

          <form className="needs-validation" action="#!" onSubmit={manageRequest}>
            <div className="d-flex flex-column signup">
              <div className="d-flex flex-column mb-3">
                <label htmlFor="email" className="form-label text-light mb-0">wallet address <span className="crypt-grayscale-600">*</span></label>
                <input type="email" className="form-control py-2" name="usdtaddress" id="usdtaddress" value={profile?.walletAddress} placeholder="enter wallet address" readOnly />
                <div className="invalid-feedback mt-0">This field is required.</div>
                {!profile?.walletAddress && (
                  <button type="button" className="btn btn-outline-primary btn-sm mt-2" onClick={ConnectWallet}>Connect Wallet</button>
                )}
              </div>

              <div className="d-flex flex-column">
                <div className="d-flex justify-content-between">
                  <label htmlFor="password" className="form-label text-light mb-0">Password <span className="crypt-grayscale-600">*</span></label>
                </div>
                <div className="input-group-append">
                  <input type="password" className="form-control form-controls py-2" name="password" value={data.password} id="password" placeholder="Password" onChange={getInput} required />
                  <div className="eye fright"><i className="fa fa-eye" id="eye"></i> </div>
                  <div className="invalid-feedback mt-0">This field is required.</div>
                </div>
              </div>
              <div className="d-flex flex-column">
                <div className="d-flex justify-content-between">
                  <label htmlFor="password" className="form-label text-light mb-0">Confirm Password <span className="crypt-grayscale-600">*</span></label>
                </div>
                <div className="input-group-append">
                  <input type="password" className="form-control form-controls py-2" name="confpassword" value={data.confpassword} id="confpassword" placeholder="confpassword" onChange={getInput} required />
                  <div className="eye fright"><i className="fa fa-eye" id="eye"></i> </div>
                  <div className="invalid-feedback mt-0">This field is required.</div>
                </div>
              </div>

              <div className="d-flex flex-column">
                <div className="d-flex justify-content-between">
                  <label htmlFor="referral" className="form-label text-light mb-0">Referral ID</label>
                </div>
                <div className="input-group-append">
                  <input type="text" className="form-control form-controls py-2" name="referralId" id="referral" placeholder="enter referral id (optional)" value={data?.referralId} onChange={getInput} onBlur={checkSponser} readOnly={referralId?true:false} />
                  {action?.message ? <small className={action?.sponserVerify ? "text-success" : "text-danger"}>{action?.message}</small> : ''}
                </div>
              </div>
              {action.btnLoader ? <button className="btn btn-primary rounded-pill text-center mt-4" type="button" disabled><div class="spinner-border" role="status" style={{ width: '17px', height: '17px' }}></div></button> : <button className="btn btn-primary rounded-pill text-center mt-4" type="submit" disabled={!action?.sponserVerify || !profile?.walletAddress}>Create Account</button>}
            </div>
          </form>

          <div className="d-flex flex-column">
            <div className="divider" role="separator"></div>
          </div>

          <div className="d-flex flex-row gap-2 mt-2 justify-content-center">
            <p className="crypt-grayscale-500">I have an account?</p>
            <Link to="/login" className="link-primary fw-bold">
              Login
            </Link>
          </div>
        </div>
      </div>
    </div>
  </>)
}
